export default __webpack_public_path__ + "static/media/ricevuta_acquisto_spc.2e65b3c4.pdf";